import { Checkbox, DatePicker, Input, Radio, Select } from 'antd'
import moment from 'moment'
import { FC } from 'react'

type Props = {
  property: Property
  value: any
  onChangeProperties: (
    propertyId: string,
    newObject: { [key: Property['field_type']]: any },
  ) => void
}

export const CustomPropertyItem: FC<Props> = ({
  property,
  value,
  onChangeProperties,
}) => {
  return (
    <>
      {property.field_type === 'text' && (
        <Input
          onChange={(e) =>
            onChangeProperties(property.id, {
              [property.field_type]: e.target.value,
            })
          }
          value={value}
        />
      )}
      {property.field_type === 'multiline_text' && (
        <Input.TextArea
          autoSize={{ minRows: 3, maxRows: 6 }}
          onChange={(e) =>
            onChangeProperties(property.id, {
              [property.field_type]: e.target.value,
            })
          }
          value={value}
        />
      )}
      {property.field_type === 'date' && (
        <DatePicker
          onChange={(e) =>
            onChangeProperties(property.id, {
              [property.field_type]: e?.toDate(),
            })
          }
          value={value ? moment(value, 'YYYY-MM-DD') : null}
        />
      )}
      {property.field_type === 'radio' && (
        <Radio.Group
          onChange={(e) =>
            onChangeProperties(property.id, {
              [property.field_type]: e.target.value,
            })
          }
          value={value}
        >
          {property.property_selections.map((v, index) => {
            return (
              <Radio key={index} value={v.name} style={{ lineHeight: '32px' }}>
                {v.name}
              </Radio>
            )
          })}
        </Radio.Group>
      )}
      {property.field_type === 'checkbox' && (
        <Checkbox.Group
          onChange={(value) =>
            onChangeProperties(property.id, { [property.field_type]: value })
          }
          value={value}
        >
          {property.property_selections.map((v, index) => {
            return (
              <Checkbox
                key={index}
                value={v.name}
                style={{ lineHeight: '32px' }}
              >
                {v.name}
              </Checkbox>
            )
          })}
        </Checkbox.Group>
      )}
      {property.field_type === 'selection' && (
        <Select
          allowClear
          onChange={(value) =>
            onChangeProperties(property.id, { [property.field_type]: value })
          }
          value={value}
          style={{ minWidth: '100px' }}
        >
          {property.property_selections.map((v, index) => {
            return (
              <Select.Option key={index} value={v.name}>
                {v.name}
              </Select.Option>
            )
          })}
        </Select>
      )}
      {property.field_type === 'number' && (
        <Input
          type="number"
          onChange={(e) =>
            onChangeProperties(property.id, {
              [property.field_type]: parseInt(e.target.value),
            })
          }
          value={value}
        />
      )}
      {property.field_type === 'datetime' && (
        <DatePicker
          showTime
          onChange={(e) =>
            onChangeProperties(property.id, {
              [property.field_type]: e?.toDate(),
            })
          }
          value={value ? moment(value, 'YYYY-MM-DD hh:mm:ss') : null}
        />
      )}
    </>
  )
}
